import { jsx as s, jsxs as q } from "react/jsx-runtime";
import * as L from "@radix-ui/react-label";
import { Slot as j } from "@radix-ui/react-slot";
import { forwardRef as l, useId as D, useState as H, useCallback as w, useMemo as A, Children as B, isValidElement as R, cloneElement as S, createContext as k, useContext as M, useEffect as V } from "react";
import { c } from "./cn-DlLpp5ix.js";
const N = k(null);
function x(i) {
  const e = M(N);
  if (!e)
    throw new Error(`<Field.${i}> must be rendered inside <Field>.`);
  return e;
}
const z = l(function({ invalid: e = !1, disabled: t = !1, required: n = !1, children: o, id: r, className: f, ...d }, g) {
  const E = D(), m = r ?? `field-${E}`, b = `${m}-description`, h = `${m}-hint`, v = `${m}-error`, [p, P] = H({
    description: !1,
    hint: !1,
    error: !1
  }), C = w(
    (a, F) => P((I) => I[a] === F ? I : { ...I, [a]: F }),
    []
  ), $ = A(() => {
    const a = [];
    return p.description && a.push(b), p.hint && a.push(h), p.error && a.push(v), {
      controlId: m,
      descriptionId: b,
      hintId: h,
      errorId: v,
      invalid: e,
      disabled: t,
      required: n,
      registerPart: C,
      hasPart: (F) => p[F],
      describedBy: a.length > 0 ? a.join(" ") : void 0
    };
  }, [m, b, h, v, e, t, n, p, C]);
  return /* @__PURE__ */ s(N.Provider, { value: $, children: /* @__PURE__ */ s(
    "div",
    {
      ref: g,
      className: c("flex flex-col gap-1.5", f),
      "data-disabled": t || void 0,
      "data-invalid": e || void 0,
      ...d,
      children: o
    }
  ) });
}), G = l(function({ children: e, className: t, ...n }, o) {
  const r = x("Label");
  return /* @__PURE__ */ q(
    L.Root,
    {
      ref: o,
      htmlFor: r.controlId,
      className: c(
        "flex items-center gap-1 text-sm font-medium text-primary",
        r.disabled && "opacity-60",
        t
      ),
      ...n,
      children: [
        /* @__PURE__ */ s("span", { children: e }),
        r.required ? /* @__PURE__ */ s("span", { "aria-hidden": "true", className: "text-error", children: "*" }) : null
      ]
    }
  );
}), J = l(
  function({ children: e, className: t, ...n }, o) {
    const r = x("Description");
    return y(r, "description"), /* @__PURE__ */ s(
      "p",
      {
        ref: o,
        id: r.descriptionId,
        className: c("text-xs text-secondary", t),
        ...n,
        children: e
      }
    );
  }
), K = l(function({ children: e, className: t, ...n }, o) {
  return /* @__PURE__ */ s("div", { ref: o, className: c("-mt-7 flex justify-end", t), ...n, children: e });
}), O = l(function({ children: e, asChild: t = !1, className: n }, o) {
  const r = x("Control");
  if (t)
    return /* @__PURE__ */ s(
      j,
      {
        ref: o,
        id: r.controlId,
        "aria-describedby": r.describedBy,
        "aria-invalid": r.invalid || void 0,
        "aria-required": r.required || void 0,
        "data-disabled": r.disabled || void 0,
        className: n,
        children: e
      }
    );
  const f = B.only(e);
  if (!R(f))
    return null;
  const d = f.props;
  return S(f, {
    id: d.id ?? r.controlId,
    "aria-describedby": U(d["aria-describedby"], r.describedBy),
    "aria-invalid": r.invalid ? !0 : d["aria-invalid"],
    "aria-required": r.required ? !0 : d["aria-required"],
    disabled: r.disabled || d.disabled,
    className: c(d.className, n)
  });
}), Q = l(function({ children: e, className: t, ...n }, o) {
  const r = x("Hint");
  return y(r, "hint"), /* @__PURE__ */ s("p", { ref: o, id: r.hintId, className: c("text-xs text-tertiary", t), ...n, children: e });
}), T = l(function({ children: e, className: t, ...n }, o) {
  const r = x("Error");
  return y(r, "error"), /* @__PURE__ */ s(
    "p",
    {
      ref: o,
      id: r.errorId,
      role: "alert",
      "aria-live": "polite",
      className: c("text-xs text-error", t),
      ...n,
      children: e
    }
  );
});
function y(i, e) {
  const { registerPart: t } = i;
  V(() => (t(e, !0), () => t(e, !1)), [t, e]);
}
function U(i, e) {
  if (!(!i && !e))
    return i ? e ? `${i} ${e}` : i : e;
}
const u = z;
u.Label = G;
u.Description = J;
u.Action = K;
u.Control = O;
u.Hint = Q;
u.Error = T;
export {
  u as F,
  K as a,
  O as b,
  J as c,
  T as d,
  Q as e,
  G as f
};
//# sourceMappingURL=Field-BUxMseAe.js.map
